import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Table,
    Modal,
    message,
    Form, Col, Row, Tooltip,
} from 'antd';
import axios from 'axios';
import {copyToClipboard, formattedAddress, formatTimestamp} from "../../util";
import { useNavigate } from 'react-router-dom';
const { Content } = Layout;
const { Option } = Select;

const BatchTransferOut = () => {
    const navigate = useNavigate();
    const [walletGroups, setWalletGroups] = useState([]);
    const [records, setRecords] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [loading, setLoading] = useState(false);
    const [detailModalVisible, setDetailModalVisible] = useState(false);
    const [detailTransfers, setDetailTransfers] = useState([]);
    const [form] = Form.useForm();
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [tokenAddress, setTokenAddress] = useState("");  // 新增：存储Token地址
    const [transferType, setTransferType] = useState('SAFE'); // 添加 transferType 状态
    const [chainType, setChainType] = useState('evm');


    useEffect(() => {
        fetchWalletGroups();
        fetchRecords();
        fetchChains(); // 获取链的列表
    }, []);

    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };


    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
            });
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch(error) {
            message.error(error);
        }
    };

    const createBatchTransferOut = async (values) => {
        setLoading(true);

        const payload = {
            group_id: values.group_id,
            type: values.type,
            chain_type: chainType, // 默认使用EVM链类型
            min_proportion: parseInt(values.min_proportion, 10), // 最小转出比例
            max_proportion: parseInt(values.max_proportion, 10), // 最大转出比例
            target_address: values.target_address,
            token_address: values.token_address,
            chain_id: selectedChain?.chain_id || null, // 使用选中的链ID
            duration_minutes: parseInt(values.duration_minutes, 10),
        };

        if (values.type === 'SAFE') {
            payload.target_address = values.target_address;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/transfers/withdraw/create', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                message.success('批量转出任务创建成功');
                fetchRecords();
            } else {
                handleError(response.data.code, response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleError = (code, data) => {
        switch (code) {
            case 3004:
                message.error('无效的转出类型');
                break;
            case 3005:
                message.error('无效的目标地址');
                break;
            case 3006:
                message.error('余额不足');
                break;
            default:
                message.error(data);
                break;
        }
    };

    const fetchRecords = async (page = 1, size = 20) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/transfers/withdraw/list', {
                params: { page, size },
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                const { items, total } = response.data.data;
                setRecords(items);
                setPagination({ current: page, pageSize: size, total });
            } else {
                message.error( response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTransferDetails = async (taskId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/transfers/withdraw/info`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    task_id: taskId
                },
            });
            if (response.data.code === 0) {
                setDetailTransfers(response.data.data.items);
                setDetailModalVisible(true);
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        }
    };

    const columns = [
        { title: '序号', dataIndex: 'index', render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize },
        { title: '钱包组', dataIndex: 'group_name' },
        { title: '代币地址', dataIndex: 'token_address' , render: (text) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* 地址链接 */}
                    <a href={`https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        { title: '链', dataIndex: 'chain_id', render: (text) => {

                return chains.map((chain) => {
                    if (chain.chain_id === text) {
                        return chain.chain_name;
                    }
                });
            }
        },
        {
            title: '金额进度',
            dataIndex: 'amount_progress',
            render: (_, record) => {
                // 将completed_amount和total_amount转换为浮点数并计算百分比
                const completedAmount = parseFloat(record.completed_amount);
                const totalAmount = parseFloat(record.total_amount);
                const progress = totalAmount > 0 ? (completedAmount / totalAmount) * 100 : 0;

                // 保留四位小数的百分比
                const progressPercentage = progress.toFixed(4);

                return (
                    <Tooltip title={`原始数据比例: ${record.completed_amount} / ${record.total_amount}`}>
                        {/* 展示百分比 */}
                        <span>{progressPercentage}%</span>
                    </Tooltip>
                );
            },
        },
        { title: '完成进度', dataIndex: 'progress', render: (_, record) => `${record.completed_account_count}/${record.total_account_count}` },
        { title: '开始时间', dataIndex: 'start_time', render: (timestamp) => formatTimestamp(timestamp) },
        { title: '预计结束时间', dataIndex: 'estimated_end_time', render: (timestamp) => formatTimestamp(timestamp) },
        {
            title: '操作',
            render: (_, record) => (
                <Button onClick={() => fetchTransferDetails(record.task_id)}>查看详情</Button>
            ),
        },
    ];

    const detailColumns = [
        { title: '序号', dataIndex: 'index', render: (_, __, index) => index + 1 },
        { title: '钱包地址', dataIndex: 'account_address',
            render: (text, record) => (

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {text}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        { title: '金额', dataIndex: 'amount' },
        { title: '比例', dataIndex: 'total_proportion', render: (text) => {return text + '%' } },
        { title: '完成状态', dataIndex: 'status',
            render: (text, record) => {
                // 如果 scan_url 为空，则不显示超链接，直接显示地址
                if(record.status === 'COMPLETED') {
                    if (!record.scan_url) {
                        return <span>已完成</span>;
                    }

                    // 如果 scan_url 存在，则显示超链接
                    return (
                        <a href={record.scan_url} target="_blank" rel="noopener noreferrer">
                            查看交易
                        </a>
                    );
                } else {
                    return '未完成'
                }

            },
        },
    ];

    return (
        <Content style={{ padding: 20 }}>
            <Form
                form={form}
                layout="horizontal"
                onFinish={createBatchTransferOut}
                style={{ marginBottom: 20 }}
            >
                {/* 第一行：5个控件 */}
                <Row gutter={16} style={{ marginBottom: 10 }}>
                    <Col span={4}>
                        <Form.Item
                            name="group_id"
                            rules={[{ required: true, message: '请选择钱包组' }]}
                        >
                            <Select
                                        allowClear
                                showSearch
                                placeholder="选择钱包组"
                                onSearch={fetchWalletGroups}
                                style={{ width: '100%' }}
                            >
                                {walletGroups.map((group) => (
                                    <Option key={group.group_id} value={group.group_id}>
                                        {group.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="type"
                            rules={[{ required: true, message: '请选择转出方式' }]}
                        >
                            <Select
                                        allowClear placeholder="转出方式" style={{ width: '100%' }}  onChange={(value) => {setTransferType(value); console.log(value);}}>
                                <Option value="FAST">快速转出</Option>
                                <Option value="SAFE">安全转出</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="chain_id"
                            rules={[{ required: true, message: '请选择链' }]}
                        >
                            <Select
                                        allowClear
                                placeholder="选择链"
                                value={selectedChain?.chain_id}
                                onChange={(value) => {
                                    const selected = chains.find(chain => chain.chain_id === value);
                                    setSelectedChain(selected);
                                    form.setFieldsValue({ token_address: '' });

                                    if (selected?.chain_name?.toLowerCase().includes('sol')) {
                                        setChainType('svm');
                                        form.setFieldsValue({ chain_type: 'SVM' })
                                    } else {
                                        setChainType('evm');
                                        form.setFieldsValue({ chain_type: 'EVM' })
                                    }
                                }}
                                style={{ width: '100%' }}
                            >
                                {chains.map((chain) => (
                                    <Option key={chain.chain_id} value={chain.chain_id}>
                                        {chain.chain_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="min_proportion"
                            label="最小比例"
                            rules={[
                                { required: true, message: '请输入最小转出比例' },
                                {
                                    validator: (_, value) =>
                                        value >= 0 && value <= 100
                                            ? Promise.resolve()
                                            : Promise.reject(new Error('最小转出比例必须在0到100之间')),
                                },
                            ]}
                        >
                            <Input
                                placeholder="最小比例"
                                addonAfter="%"
                                style={{ width: '100%' }}
                                type="number" // 限制只能输入数字
                            />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="max_proportion"
                            label="最大比例"
                            rules={[
                                { required: true, message: '请输入最大转出比例' },
                                {
                                    validator: (_, value) =>
                                        value >= 0 && value <= 100
                                            ? Promise.resolve()
                                            : Promise.reject(new Error('最大转出比例必须在0到100之间')),
                                },
                            ]}
                        >
                            <Input
                                placeholder="最大比例"
                                addonAfter="%"
                                style={{ width: '100%' }}
                                type="number" // 限制只能输入数字
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* 第二行：4个控件 */}
                <Row gutter={16} style={{ marginBottom: 10 }}>
                    <Col span={3}>
                        <Form.Item
                            name="chain_type"
                            rules={[{ required: true, message: '请选择链类型' }]}
                            initialValue="evm"
                        >
                            <Select
                                placeholder="链类型"
                                value={chainType}
                                onChange={(value) => setChainType(value)}
                                style={{ width: '100%' }}
                            >
                                <Option value="evm">EVM</Option>
                                <Option value="svm">SVM</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="target_address"
                            rules={[{ required: true, message: '请输入转出地址' }]}
                        >
                            <Input placeholder="转出地址" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="token_address"
                            rules={[{ required: true, message: '请输入代币地址' }]}
                        >
                            <Input placeholder="代币地址" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    {transferType && !transferType.includes('FAST') && (
                    <Col span={4}>
                        <Form.Item
                            name="duration_minutes"
                            rules={[
                                { required: true, message: '请输入执行时间' },
                                {
                                    validator: (_, value) =>
                                        Number.isInteger(+value) && +value > 0
                                            ? Promise.resolve()
                                            : Promise.reject(new Error('时间必须为正整数')),
                                },
                            ]}
                        >
                            <Input placeholder="执行时间(分钟)" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    )}

                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} block>
                                批量转出
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Table
                rowKey="task_id"
                columns={columns}
                dataSource={records}
                loading={loading}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onChange: fetchRecords,
                    showSizeChanger: false,
                }}
            />

            <Modal
                title="批量转出详情"
                visible={detailModalVisible}
                onCancel={() => setDetailModalVisible(false)}
                footer={null}
                width={1000} // 设置宽度
            >
                <Table rowKey="address" columns={detailColumns} dataSource={detailTransfers} />
            </Modal>
        </Content>
    );
};

export default BatchTransferOut;
